import React, { useState } from 'react';
import Helmet from 'react-helmet';
import MaterialTable from 'material-table';
import Box from '@material-ui/core/Box';
import { Query, useMutation } from 'react-apollo';
import {
  GET_ALL_ADDONS,
  GET_ALL_PRODUCTS,
  UPSERT_ADDON,
  UPSERT_PRODUCT,
} from 'graphql/products';
import Spin from 'components/common/Spin';
import ProductForm from './ProductForm';
import Toggle from '@material-ui/core/Switch';
import { FormControlLabel, Typography } from '@material-ui/core';

const CONTRACT_URL = `https://weadmit-static.s3.us-east-2.amazonaws.com/contracts/`;

const Products = ({ }) => {
  const [showAdd, setShowAdd] = useState(false);
  const [upsertProduct] = useMutation(UPSERT_PRODUCT);
  const [upsertAddon] = useMutation(UPSERT_ADDON);
  const [addonForm, showAddonForm] = React.useState(false);
  const [addonTable, showAddonTable] = React.useState(false);

  const toggleAdd = () => {
    setShowAdd(!showAdd);
  };

  const handleAddonTableDisplay = (e) => {
    showAddonTable(e.target.checked);
    showAddonForm(e.target.checked);
  };

  const COLS = [
    {
      title: 'id',
      field: 'id',
    },
    {
      title: 'Enabled',
      field: 'active',
      type: 'boolean',
    },
    {
      title: 'name',
      field: 'package_name',
    },
    {
      title: 'Grad year',
      field: 'graduation_year',
    },
    {
      title: 'End Date',
      field: 'program_end_date',
      type: 'date',
    },
    {
      title: 'Plan ID',
      field: 'plan_id',
    },
    {
      title: 'Pricing model',
      field: 'pricing_model',
    },
    {
      title: 'Installments',
      field: 'installments',
    },
    {
      title: 'Type',
      field: 'product_type',
    },
    {
      title: 'Total',
      field: 'total',
    },
    {
      title: 'Signup fee',
      field: 'signup_fee',
    },
    {
      title: 'MBG Period',
      field: 'mbg_period',
    },
    {
      title: 'Tier prices',
      field: 'tier_prices',
    },
    {
      title: 'Stripe Product ID',
      field: 'stripe_product_id',
    },
    {
      title: 'Contract',
      field: 'contract_filename',
      render: (row) => (
        <a href={`${CONTRACT_URL}${row.contract_filename}`} target="_blank">
          {row.contract_filename}
        </a>
      ),
    },
  ];

  const COLS_ADDON = [
    {
      title: 'id',
      field: 'id',
    },

    {
      title: 'name',
      field: 'package_name',
    },
    {
      title: 'Product Type',
      field: 'product_type',
      render: (row) => {
        const list = row.product_type.map((m) => `${m.label}`);
        return list.join(', ');
      },
    },
    {
      title: 'Credit Type',
      field: 'credit_type',
    },
    {
      title: 'Class Year',
      field: 'class_year',
      render: (row) => {
        const list = row.class_year.map((m) => `${m.label}`);
        return list.join(', ');
      },
    },
    {
      title: 'Price',
      field: 'price',
    },
  ];

  return (
    <Box>
      <Helmet title="Products" />
      <Query query={!addonTable ? GET_ALL_PRODUCTS : GET_ALL_ADDONS}>
        {({ data, loading, refetch }) => {
          if (loading) return <Spin linear spinning />;

          const onSave = async (data) => {
            await upsertProduct({ variables: { data } }).then(() => refetch());
          };

          const onSaveAddon = async (data) => {
            await upsertAddon({ variables: { data } }).then(() => refetch());
          };

          return (
            <Box>
              <FormControlLabel
                control={
                  <Toggle
                    checked={addonTable}
                    onChange={handleAddonTableDisplay}
                    name="showAddonTable"
                  />
                }
                label={
                  <Typography color="primary" variant="body2">
                    {' '}
                    {'Show Addons'}
                  </Typography>
                }
              />
              <MaterialTable
                columns={!addonTable ? COLS : COLS_ADDON}
                data={!addonTable ? data.products : data.addons}
                options={{
                  showTitle: false,
                  pageSize: 20,
                }}
                actions={[
                  {
                    icon: 'add',
                    tooltip: 'Add Product',
                    isFreeAction: true,
                    onClick: toggleAdd,
                  },
                ]}
                onRowClick={(e, row) => setShowAdd(row)}
              />
              {showAdd && (
                <ProductForm
                  product={showAdd && showAdd.id ? showAdd : null}
                  onSubmit={onSave}
                  onSubmitAddon={onSaveAddon}
                  addonForm={addonForm}
                  showAddonForm={showAddonForm}
                  onClose={toggleAdd}
                  plan_id={showAdd.plan_id}
                  productData={data.products}
                />
              )}
            </Box>
          );
        }}
      </Query>
    </Box>
  );
};

export default Products;
